import React from "react";
import DownLoadTpl from "@src/components/import/downLoadTpl.tsx";
import ImportCom from "@src/components/import/import.tsx";
import { requiredValidate } from "../utils";

export enum DownLoadType {
  "downLoadTpl", // 下载新增模板
  "downUpdateLoadTpl", // 下载更新模板
}

export enum ImportType {
  "newAddImport", // 新增导入
  "updateImport", // 更新导入
}

// 测试前置 后置钩子
// export const downLoadTpl = {
//   beforeDownLoadTplHook(rootStore, data) {
//     data.params.v = 1;
//     return data;
//   },
//   afterDownLoadTplHook(rootStore, data) {
//     rootStore.utils.message.success('我是后置钩子')
//   },
//   async doAction(rootStore: any, options: any = {}) {
//     const { pageStore } = rootStore;
//     const _this = this;
//     pageStore.openModal({
//       uiType: "component",
//       title: "下载/制作模板",
//       bodyStyle: {
//         height: "500px",
//       },
//       component: (
//         <DownLoadTpl
//           rootStore={rootStore}
//           beforeDownLoadTplHook={_this.beforeDownLoadTplHook}
//           afterDownLoadTplHook={_this.afterDownLoadTplHook}
//         ></DownLoadTpl>
//       ),
//     });
//   },

// };

/**
 * @description: 下载模板
 * @param {any} rootStore
 * @param options {
 * @hooks {
 *  // 专有钩子
 *  beforeDownLoadTplHook: 下载请求前钩子
 *  afterDownLoadTplHook: 下载请求后钩子
 *  // 公共钩子
 *  beforeHook: 开始钩子
 *  afterHook: 结束钩子
 *  catchHook: 异常钩子
 *  finallyHook: 最终钩子
 * }
 */
export async function downLoadTpl(rootStore: any, options: any = {}) {
  const { pageStore, utils } = rootStore;
  try {
    requiredValidate.call(this, options, ["detailBillNo"]);
  } catch (e: any) {
    return utils.message.danger(e.message);
  }

  const _this = this;
  pageStore.openModal({
    uiType: "component",
    title: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80059', '下载'),
    bodyStyle: {
      height: "500px",
    },
    component: (
      <DownLoadTpl
        rootStore={rootStore}
        beforeDownLoadTplHook={_this.beforeDownLoadTplHook}
        afterDownLoadTplHook={_this.afterDownLoadTplHook}
        type={DownLoadType.downLoadTpl}
        options={options}
      ></DownLoadTpl>
    ),
  });
}

// // 测试前置 后置钩子
// export const newAddImport = {
//   beforeNewAddImportHook(rootStore, data) {
//     data.params.v = 1;
//     return data;
//   },
//   afterNewAddImportHook(rootStore, data) {
//     alert(1)
//   },
//   async doAction(rootStore: any, options: any = {}) {
//     const { pageStore } = rootStore;
//     const _this = this;
//     pageStore.openModal({
//       uiType: "component",
//       title: "导入工作台",
//       bodyStyle: {
//         height: "500px",
//       },
//       okText: "导入",
//       component: (
//         <NewAddImport
//           rootStore={rootStore}
//           {...options}
//           beforeNewAddImportHook={_this.beforeNewAddImportHook}
//           afterNewAddImportHook={_this.afterNewAddImportHook}
//         ></NewAddImport>
//       ),
//     });
//   }
// };

/**
 * @description: 下载模板
 * @param {any} rootStore
 * @param options
 * filterStoreKey: string，查询store键值，用户导入后刷新列表使用
 * @hooks {
 *  // 专有钩子
 *  beforeNewAddImportHook: 导入请求前钩子
 *  afterNewAddImportHook: 导入请求后钩子
 *  // 公共钩子
 *  beforeHook: 开始钩子
 *  afterHook: 结束钩子
 *  catchHook: 异常钩子
 *  finallyHook: 最终钩子
 * }
 */
export async function newAddImport(rootStore: any, options: any = {}) {
  const { pageStore, utils } = rootStore;
  try {
    requiredValidate.call(this, options, ["filterStoreKey","detailBillNo"]);
  } catch (e: any) {
    return utils.message.danger(e.message);
  }

  const _this = this;
  pageStore.openModal({
    uiType: "component",
    title: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80057', '导入工作台'),
    bodyStyle: {
      height: "500px",
    },
    okText: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80058', '导入'),
    component: (
      <ImportCom
        rootStore={rootStore}
        {...options}
        beforeNewAddImportHook={_this.beforeNewAddImportHook}
        afterNewAddImportHook={_this.afterNewAddImportHook}
        type={ImportType.newAddImport}
      ></ImportCom>
    ),
  });
}

/**
 * 下载更新模板
 * @param rootStore
 * @param options
 */
export async function downLoadUpdateTpl(rootStore: any, options: any = {}) {
  const { pageStore, utils } = rootStore;
  try {
    requiredValidate.call(this, options, [
      "tableStoreKey",
      "filterStoreKey",
      "pagingStoreKey",
      "datasourceAlias",
      "detailBillNo"
    ]);
  } catch (e: any) {
    return utils.message.danger(e.message);
  }

  const _this = this;
  pageStore.openModal({
    uiType: "component",
    title: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80059', '下载'),
    bodyStyle: {
      height: "500px",
    },
    component: (
      <DownLoadTpl
        rootStore={rootStore}
        beforeDownLoadTplHook={_this.beforeDownUpdateLoadTplHook}
        afterDownLoadTplHook={_this.afterDownUpdateLoadTplHook}
        options={options}
        type={DownLoadType.downUpdateLoadTpl}
      ></DownLoadTpl>
    ),
  });
}

/**
 * @description: 下载模板
 * @param {any} rootStore
 * @param options
 * filterStoreKey: string，查询store键值，用户导入后刷新列表使用
 * @hooks {
 *  // 专有钩子
 *  beforeNewAddImportHook: 导入请求前钩子
 *  afterNewAddImportHook: 导入请求后钩子
 *  // 公共钩子
 *  beforeHook: 开始钩子
 *  afterHook: 结束钩子
 *  catchHook: 异常钩子
 *  finallyHook: 最终钩子
 * }
 */
export async function updateImport(rootStore: any, options: any = {}) {
  const { pageStore, utils } = rootStore;
  try {
    requiredValidate(this, options, ["filterStoreKey","detailBillNo"]);
  } catch (e: any) {
    return utils.message.danger(e.message);
  }
  const _this = this;
  pageStore.openModal({
    uiType: "component",
    title: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80057', '导入工作台'),
    bodyStyle: {
      height: "500px",
    },
    okText: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80058', '导入'),
    component: (
      <ImportCom
        rootStore={rootStore}
        {...options}
        beforeUpdateImportHook={_this.beforeUpdateImportHook}
        afterUpdateImportHook={_this.afterUpdateImportHook}
        type={ImportType.updateImport}
      ></ImportCom>
    ),
  });
}
